"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Button_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Button"));
var polished_1 = require("polished");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utilities_1 = require("../../../utilities/utilities");
var FAQ_1 = require("../FAQ");
var Text_1 = tslib_1.__importDefault(require("../FormattedText/Text"));
var CONTROL_HEIGHT = 24;
var OPEN_ALL_EVENT_NAME = 'content-widget-hiddenContent-openAll';
var CLOSE_ALL_EVENT_NAME = 'content-widget-hiddenContent-closeAll';
var FaqLayoutWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border: 1px solid #dddddd;\n  border-radius: ", ";\n  position: relative;\n  padding: 0 ", ";\n"], ["\n  border: 1px solid #dddddd;\n  border-radius: ", ";\n  position: relative;\n  padding: 0 ", ";\n"])), polished_1.rem(8), polished_1.rem(16));
var QuestionWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var Control = styled_components_1["default"].button(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  margin: 0 ", ";\n  border-radius: ", "\n    ", " 0 0;\n  border: 1px solid #dddddd;\n  border-bottom: none;\n  cursor: pointer;\n  display: inline-flex;\n  width: auto;\n  align-items: center;\n  justify-content: center;\n  outline: 0;\n  background: #fff;\n  vertical-align: baseline;\n  padding: 0 ", ";\n  text-transform: none;\n  text-shadow: none;\n  font-weight: normal;\n  line-height: 1;\n  font-style: normal;\n  font-size: ", ";\n  text-decoration: none;\n  user-select: none;\n  font-family: ", ";\n  transition: background-color 0.1s ease, color 0.1s ease, background 0.1s ease;\n  &:hover {\n    background: #dddddd;\n  }\n"], ["\n  height: ", ";\n  margin: 0 ", ";\n  border-radius: ", "\n    ", " 0 0;\n  border: 1px solid #dddddd;\n  border-bottom: none;\n  cursor: pointer;\n  display: inline-flex;\n  width: auto;\n  align-items: center;\n  justify-content: center;\n  outline: 0;\n  background: #fff;\n  vertical-align: baseline;\n  padding: 0 ", ";\n  text-transform: none;\n  text-shadow: none;\n  font-weight: normal;\n  line-height: 1;\n  font-style: normal;\n  font-size: ", ";\n  text-decoration: none;\n  user-select: none;\n  font-family: ", ";\n  transition: background-color 0.1s ease, color 0.1s ease, background 0.1s ease;\n  &:hover {\n    background: #dddddd;\n  }\n"])), polished_1.rem(CONTROL_HEIGHT), polished_1.rem(2), function (_a) {
    var theme = _a.theme;
    return theme.largeBorderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.largeBorderRadius;
}, polished_1.rem(8), polished_1.rem(11), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
});
var ButtonWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  justify-content: ",
    ";\n"])), function (_a) {
    var buttonPosition = _a.buttonPosition;
    return buttonPosition === 'left'
        ? 'flex-start'
        : buttonPosition === 'right'
            ? 'flex-end'
            : 'center';
});
var TitleWrapper = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  border: 1px solid #dddddd;\n  border-radius: ", ";\n  margin-bottom: ", ";\n  padding: 0 ", ";\n"], ["\n  border: 1px solid #dddddd;\n  border-radius: ", ";\n  margin-bottom: ", ";\n  padding: 0 ", ";\n"])), polished_1.rem(8), polished_1.rem(16), polished_1.rem(16));
var HiddenContentLink = styled_components_1["default"].button(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  cursor: pointer;\n  text-decoration: none;\n  :hover,\n  :active,\n  :focus {\n    text-decoration: underline;\n  }\n  color: ", ";\n  padding: 0;\n  border: none;\n  font: inherit;\n  color: ", ";\n  background-color: transparent;\n  text-align: inherit;\n"], ["\n  cursor: pointer;\n  text-decoration: none;\n  :hover,\n  :active,\n  :focus {\n    text-decoration: underline;\n  }\n  color: ", ";\n  padding: 0;\n  border: none;\n  font: inherit;\n  color: ", ";\n  background-color: transparent;\n  text-align: inherit;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var color = _a.color;
    return color;
});
var WidgetHiddenContent = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, renderEmpty = _a.renderEmpty;
    var _c = react_1["default"].useState(false), isOpened = _c[0], setIsOpened = _c[1];
    var _d = react_1["default"].useState(false), controlsShown = _d[0], setControlsShown = _d[1];
    var wrapperEl = react_1["default"].useRef(null);
    var _e = react_1["default"].useState(-1), prevScrollPosition = _e[0], setPrevScrollPosition = _e[1];
    if (!data.layout && renderEmpty) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('hiddenContent'));
    }
    react_1["default"].useEffect(function () {
        var el = document.getElementById("collapsible-content-" + data.elementId);
        if (el) {
            el.style.display = isOpened ? 'block' : 'none';
        }
    }, [isOpened]);
    react_1["default"].useEffect(function () {
        if (data.layout !== 'faq') {
            return;
        }
        function handleOpenAllEvent() {
            setIsOpened(true);
        }
        function handleCloseAllEvent() {
            setIsOpened(false);
        }
        document.addEventListener(OPEN_ALL_EVENT_NAME, handleOpenAllEvent, false);
        document.addEventListener(CLOSE_ALL_EVENT_NAME, handleCloseAllEvent, false);
        return function () {
            if (data.layout !== 'faq') {
                document.removeEventListener(OPEN_ALL_EVENT_NAME, handleOpenAllEvent, false);
                document.removeEventListener(CLOSE_ALL_EVENT_NAME, handleCloseAllEvent, false);
            }
        };
    }, [data.layout]);
    // handle scroll back after all FAQs have been opened
    react_1["default"].useLayoutEffect(function () {
        var el = wrapperEl.current;
        if (prevScrollPosition < 0 || !el) {
            return;
        }
        var scrollParent = utilities_1.getScrollParent(el);
        var top = utilities_1.getOffsetTopRelativeToParent(el, scrollParent) - prevScrollPosition;
        scrollParent.scroll(0, top);
        setPrevScrollPosition(-1);
    }, [prevScrollPosition]);
    var handleHiddenContentClick = function () {
        setIsOpened(!isOpened);
    };
    var handleOpenAll = react_1["default"].useCallback(function () {
        var _a;
        var prevPosition = ((_a = wrapperEl.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) || 0;
        var e = new Event(OPEN_ALL_EVENT_NAME);
        document.dispatchEvent(e);
        setPrevScrollPosition(prevPosition);
    }, []);
    var handleCloseAll = react_1["default"].useCallback(function () {
        var _a;
        var prevPosition = ((_a = wrapperEl.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) || 0;
        var e = new Event(CLOSE_ALL_EVENT_NAME);
        document.dispatchEvent(e);
        setPrevScrollPosition(prevPosition);
    }, []);
    var renderFaqLayout = function () {
        return (react_1["default"].createElement(FaqLayoutWrapper, { className: "content-widget-hiddenContent-FaqLayoutWrapper", ref: wrapperEl, onMouseEnter: function () {
                setControlsShown(true);
            }, onMouseLeave: function () {
                setControlsShown(false);
            } },
            react_1["default"].createElement(QuestionWrapper, { onClick: handleHiddenContentClick },
                react_1["default"].createElement(Text_1["default"], { text: data.title || '<p><br></p>' })),
            controlsShown && (react_1["default"].createElement(FAQ_1.Controls, null,
                react_1["default"].createElement(Control, { onClick: handleOpenAll, type: "button" }, "+ Rozba\u013E v\u0161etky"),
                react_1["default"].createElement(Control, { onClick: handleCloseAll, type: "button" }, "- Zba\u013E v\u0161etky")))));
    };
    var renderReadMoreButtonLayout = function () {
        return (react_1["default"].createElement(react_1["default"].Fragment, null, (!isOpened || (isOpened && !data.hideButtonAfterUncover)) && (react_1["default"].createElement(react_1["default"].Fragment, null,
            data.title && (react_1["default"].createElement(TitleWrapper, { className: "content-widget-hiddenContent-TitleWrapper" },
                react_1["default"].createElement(Text_1["default"], { text: data.title || '<p><br></p>' }))),
            react_1["default"].createElement(ButtonWrapper, { className: "content-widget-hiddenContent-ButtonWrapper", buttonPosition: data.buttonPosition }, data.showAsLink ? (react_1["default"].createElement(HiddenContentLink, { onClick: handleHiddenContentClick, className: "content-widget-hiddenContent-readMoreButtonLink" }, isOpened ? data.buttonHideText : data.buttonUncoverText)) : (react_1["default"].createElement(Button_1["default"], { className: "content-widget-hiddenContent-readMoreButtonLink", primary: true, onClick: handleHiddenContentClick }, isOpened ? data.buttonHideText : data.buttonUncoverText)))))));
    };
    return (react_1["default"].createElement(react_1["default"].Fragment, null, data.layout === 'faq' ? renderFaqLayout() : renderReadMoreButtonLayout()));
};
exports["default"] = react_1["default"].memo(WidgetHiddenContent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
